import React from "react";

function DailyPlanEmailStatus({ cell }) {
  function mailSentToFactory() {
    if (cell.row.original.isMailSentToFactory === 1) {
      return true;
    }
  }
  function mailSentToJD() {
    if (cell.row.original.isMailSentToJD === 1) {
      return true;
    }
  }
  function mailSentToTransporter() {
    if (cell.row.original.isMailSentToTransporter === 1) {
      return true;
    }
  }
  return (
    <>
      <div
        style={{
          width: "100px",
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        {mailSentToFactory() && (
          <div
            style={{
              background: "#ff845e",
              color: "white",
              width:"20px",
              textAlign: "center",
              borderRadius: "5px",
              boxShadow:"3px 4px 0px 0px rgb(0 0 0 / 13%)"
            }}
          >
            F
          </div>
        )}
        {mailSentToJD() && (
          <div
            style={{
              background: "#ffb200",
              color: "white",
              textAlign: "center",
              borderRadius: "5px",
              boxShadow:"3px 4px 0px 0px rgb(0 0 0 / 13%)"
            }}
          >
            <span style={{padding:"5px"}}>JD</span>
          </div>
        )}
        {mailSentToTransporter() && (
          <div
            style={{
              background: "#00a533",
              color: "white",
              width: "20px",
              textAlign: "center",
              borderRadius: "5px",
              boxShadow:"3px 4px 0px 0px rgb(0 0 0 / 13%)"
            }}
          >
            T
          </div>
        )}
      </div>
    </>
  );
}
export default DailyPlanEmailStatus;
